import React from "react";
import logo from "../../img/logo-02.png";
import { useRef, useContext, useEffect } from "react";
import auth from "../../firebase";
import { Link } from "react-router-dom";
import { MyContext} from "../../context";
import { useNavigate } from 'react-router-dom'
import supabase from "../../Supa";
import ClientNavDropMenu from "./ClientNavDropMenu"


function Nav() {
  let navigate = useNavigate()

  const { updateUsersEmail, updateUserName, userName, usersEmail } = useContext(MyContext);
  

  useEffect(() => {
    
        
      const Emaildata =  window.localStorage.getItem("UserEmail");
      const Namedata =  window.localStorage.getItem("UserName").replace(/"/g, '');
      
      if(Emaildata !== null && Namedata !== null && userName === "User"){
        updateUsersEmail(Emaildata);
        updateUserName(Namedata);
        }
      /*if(Emaildata !== null && Namedata !== null && userName === "User"){
      updateUsersEmail(JSON.parse(Emaildata));
      updateUserName(JSON.parse(Namedata));
      }*/
      console.log(Namedata)
    
  }, []);

  
  const dropdownRef = useRef();




  return (
    <>
      <div className="topbar">
        <nav className="navbar navbar-light topbarWrapper">
          <div className="topLeft">
            <span>
              
         
            </span>
          </div>
          <div className="topRight">
            <p className="NavName">{userName}</p>
            <img
              src="https://images.pexels.com/photos/3786525/pexels-photo-3786525.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
              width={"35px"}
              height={"35px"}
              alt="Profile_image"
              className="topAvatar"
            />
            <div className="topbarIconsContainer homeIcon">
            <Link to="/home" className="IconLink">
                     <span className="material-symbols-rounded ">home</span>
                  </Link>
             
            
            </div>{/**/}


            <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link topbarIconsContainer IconLink"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="material-symbols-rounded">notifications</span>
                  <span className="topIconBag">4 </span>
                </div>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <div className="dropdown-item" >
                    notifications
                  </div>
                </div>
              </div>

            
            <div className="topbarIconsContainer divider">



              <div className="dropdown" ref={dropdownRef}>
             
                <div
                  className="nav-link "
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="material-symbols-rounded">menu</span>
                </div>

                <ClientNavDropMenu />

              </div>



            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Nav;
